import { render, staticRenderFns } from "./GetPIPrimaryAffiliation.vue?vue&type=template&id=1a2128bc&scoped=true"
import script from "./GetPIPrimaryAffiliation.vue?vue&type=script&lang=js"
export * from "./GetPIPrimaryAffiliation.vue?vue&type=script&lang=js"
import style0 from "./GetPIPrimaryAffiliation.vue?vue&type=style&index=0&id=1a2128bc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2128bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCombobox,VFlex,VForm,VLayout})
